<template>
  <a-card :bordered="false">
    <div class='mb10 s_flex_bian_c'>
      <span class='mr15'>
        <a-button type="primary" @click="addMode=true">
          <PlusOutlined />
          添加条件
        </a-button>
      </span>
      <div>
        <span class='mr15'>
          <a-button type="primary" @click="updateWayVisible=true">
            <PlusOutlined />
            设置更新方式
          </a-button>
        </span>
        <span class='mr15'>
          <a-button type="primary" @click="updateData">
            <PlusOutlined />
            数据更新
          </a-button>
        </span>
        <span class='mr15'>
          <a-button type="primary" @click="detail">
            <PlusOutlined />
            刷新页面
          </a-button>
        </span>
      </div>
    </div>
    <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a @click="record.add_type==1?showOut(record):showCondition(record)" href="javascript:;" style="display:block">查看</a>
              </a-menu-item>
                  <a-menu-item v-if="record.add_type==2">
                <a @click="showOut(record)" href="javascript:;" style="display:block">查看匹配出库单</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="record.add_type==1?editOut(record):editCondition(record)" href="javascript:;" style="display:block">编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="showLogs(record)" href="javascript:;" style="display:block">查看更新明细</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="delHandle(record);" href="javascript:;" style="display:block">删除</a>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
  </a-card>
  <!-- 数据更新日志 -->
  <a-modal :keyboard="false" title="数据更新日志" v-model:visible="logVisible" centered :width='1000'  destroyOnClose :confirm-loading="confirmLoading">
    <a-table :pagination='false' :loading='listLoading' bordered :columns='logColumns' :data-source='logList'>
    </a-table>
    <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="logSearch.page" :page-size="logSearch.limit" :total="logSearch.total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  </a-modal>
  <!-- 出库条件 -->
  <a-modal :keyboard="false" v-model:visible="warehousingListVisible"  :maskClosable="false" centered :width='1000' :footer="null" destroyOnClose :confirm-loading="confirmLoading">
    <warehousingSelect v-on:select="selectWare" :selectList="outList" :is_edit="is_edit" />
  </a-modal>
  <!--创建弹框 -->
    <div v-if="addMode" class="customerModal">
    <div class="mask" @click.stop="addMode=false"></div>
    <div class="ModalContent">
      <div class=" " @click="warehousingListVisible=true;addMode=false;is_edit=false;">
        <img src="@/assets/images/guide/sd.png" alt="" class="m-b-10 m-l-10 ">
        <p>手动添加出库单</p>
      </div>
      <div class=""  @click="conditionVisible=true;addMode=false;is_edit=false;">
        <img src="@/assets/images/guide/auto.png" alt="" class="m-b-10 m-l-10 ">
        <p>按条件自动匹配</p>
      </div>
    </div>
  </div>
  <!-- <a-modal v-model:visible="addMode" centered :footer="null">
    <div class='s_flex_bian_c p-30'>
      <div class="s_flex_fdc s_flex_ali hover-show p-20" >
        <img src="@/assets/images/guide/sd.png" alt="" class="m-b-10 m-l-10 width-100">
        <p></p>
      </div>
      <div class="s_flex_fdc s_text_c s_flex_ali hover-show p-20">
        <img src="@/assets/images/guide/auto.png" alt="" class="m-b-10 m-l-10 width-100">
        <p></p>
      </div>
    </div>
  </a-modal> -->
  <!--条件选择 -->
  <a-modal v-model:visible="conditionVisible" centered title="按条件自动匹配" :width="1000" :footer="null">
    <condition v-on:success="successCondition" :activity_id="activity_id" :is_edit="is_edit" v-if="conditionVisible" />
  </a-modal>

  <!--更新方式 -->
  <a-modal v-model:visible="updateWayVisible" centered title="更新设置方式" @ok='setWay'>
    <a-radio-group name="radioGroup" v-model:value="updateValue">
      <a-radio :value="0">手动更新</a-radio>
      <a-radio :value="1">自动更新 <a-tooltip placement='right'>
          <template #title>系统会每天凌晨12点根据设置的出货条件从智能防窜应用中自动读取更新符合条件的码，自动添加到码范围中
          </template>
          <QuestionCircleOutlined class="s_c376" />
        </a-tooltip>
      </a-radio>
    </a-radio-group>
  </a-modal>
  <!--查看 -->
  <a-modal v-model:visible="outDetail" centered title="查看详情" :width="1000"  >
    <a-form ref='form' :model='outSearch' :style="{'marginBottom':'25px'}" :initialValues="outSearch" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keywords'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="outSearch.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="to">收货人</a-select-option>
            <a-select-option value="sn">单号</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="outSearch.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建日期" name='time'>
        <a-range-picker  valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table bordered :columns='outColumns' :data-source='outList'>
    </a-table>
  </a-modal>
  <!--自动查看 -->
  <a-modal v-model:visible="autoDetailVisible" centered title="查看详情" :width="1000" @ok="autoDetailVisible=false">
    <a-tabs >
      <a-tab-pane key="1" tab="发货时间">
        <div>收货时间:{{autoDetail.time_info.start_time}}-{{autoDetail.time_info.end_time}}</div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="收货经销商" v-if="autoDetail.dealer_info.length">
        <a-table bordered :columns='dealerColumns' :data-source='autoDetail.dealer_info'>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="3" tab="收货门店" v-if="autoDetail.store_info.length">
        <a-table bordered :columns='storeColumns' :data-source='autoDetail.store_info'>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="4" tab="出货商品" v-if="autoDetail.product_info.length">
        <a-table bordered :columns='goodsColumns' :data-source='autoDetail.product_info'>
          <template v-slot:info="{record}">
            <a-card-meta>
              <template #avatar>
                <img :src="info.picdomain+(record.product_image||record.cover_image_url)" alt="" style="width:50px;height: 50px;object-fit:cover">
              </template>
              <template #description>{{record.product_name}}</template>
            </a-card-meta>
          </template>
          <template v-slot:category="{ record }">
            <p v-if='record.category_name'>{{record.category_name || '未分类'}}</p>
            <p v-else>{{record.category.name || '未分类'}}</p>
          </template>
        </a-table>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
import {
  activitysRangeList,
  activitysSnRangeUpdateData,
  activitysSnRangeUpdateDataLogs,
  set_out_warehousing_list,
  update_out_warehousing_list,
  delRanges,
  activitysRangeOutList,
  activitysSwitch,
  show_range_info,
} from "@/api/qrcodeActivitys";
import { onMounted, ref } from "@vue/runtime-core";
import { iscode } from "@/utils/app";
import { message, Modal } from "ant-design-vue";
import useTableSearch from "@/hooks/useTableSearch";
import warehousingSelect from "./components/warehousingSelect.vue";
import condition from "./components/condition.vue";
import store from '@/store';
import { DownOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
const columns = [
  {
    title: "条件组合",
    dataIndex: "add_type_text",
    key: "add_type_text",
  },
  {
    title: "符合条件物流码数",
    dataIndex: "code_num",
    key: "code_num",
  },
  {
    title: "添加时间",
    key: "created_time",
    dataIndex: "created_time",
  },
  {
    title: "最后更新时间",
    dataIndex: "last_change_time",
    key: "last_change_time",
  },
  {
    title: "操作",
    key: "action",
    width: 150,
    slots: { customRender: "action" },
  },
];
export default {
  props: {
    activity_id: Number,
  },
  components: {
    warehousingSelect,
    condition,
    DownOutlined,
    QuestionCircleOutlined,
  },
  setup(props) {
    // 更新设置方式
    const updateWayVisible = ref(false);
    const updateValue = ref("");
    const setWay = async () => {
      let result = await activitysSwitch(props.activity_id, {
        activity_id: props.activity_id,
        refresh_mode: updateValue.value,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        updateWayVisible.value = false;
        detail();
      }
    };
    // 获取详情
    const list = ref();
    const listLoading = ref(false);
    var detail = async () => {
      listLoading.value = true;
      let result = await activitysRangeList(props.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      listLoading.value = false;
      if (iscode(result, true)) {
        list.value = result.data.data;
        updateValue.value = result.data.refresh_mode;
      }
    };
    // 删除
    const del = () => {};
    const updateData = async () => {
      let result = await activitysSnRangeUpdateData(props.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      iscode(result, true);
    };
    onMounted(() => {
      detail();
    });
    // 数据更新记录
    let logColumns = [
      {
        title: "更新时间",
        dataIndex: "last_change_time",
        key: "last_change_time",
      },
      {
        title: "更新前码数量",
        dataIndex: "code_num_before",
        key: "code_num_before",
      },
      {
        title: "更新后码数量",
        dataIndex: "code_num_after",
        key: "code_num_after",
      },
      {
        title: "变更数量",
        dataIndex: "code_num_change",
        key: "code_num_change",
      },
    ];
    const logList = ref();
    const logVisible = ref(false);
    const logSearch = ref({
      limit: 10,
      page: 1,
      total: 0,
    });
    const showLogs = async (data) => {
      if (data) {
        logSearch.value = {
          limit: 10,
          page: 1,
          range_id: data.range_id,
          total: 0,
        };
      }
      let result = await activitysSnRangeUpdateDataLogs(
        logSearch.value.range_id,
        logSearch.value
      )
        .then((res) => res.data)
        .catch((error) => error);
      logList.value = result.data.data;
      logSearch.value.total = result.data.total;
      logVisible.value = true;
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      logSearch.value.page = page;
      showLogs();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      logSearch.value.page = 1;
      logSearch.value.limit = limit;
      showLogs();
    };
    // 更新记录 结束
    // 添加条件模式选择
    const addMode = ref(false);
    //
    const warehousingListVisible = ref(false);
    const selectWare = async (data) => {
      console.log(data)
      if(!data.selectList)return
      const hide = message.loading("正在加载中...", 0);
      let result;
      if (!data.is_edit) {
        result = await set_out_warehousing_list({
          out_warehousing_sns: data.selectList,
          activity_id: props.activity_id,
        })
          .then((res) => res.data)
          .catch((error) => error);
      } else {
        result = await update_out_warehousing_list({
          out_warehousing_sns: data.selectList,
          range_id: data.is_edit,
          activity_id: props.activity_id,
        })
          .then((res) => res.data)
          .catch((error) => error);
      }

      console.log(result);
      setTimeout(hide);
      if (iscode(result, true)) {
        warehousingListVisible.value = false;
        outList.value=[]
        detail();
      }
    };
    // 条件
    const conditionVisible = ref(false);
    const successCondition = () => {
      conditionVisible.value = false;
      detail();
    };

    // 删除条件
    const delHandle = (value) => {
      Modal.confirm({
        centered: true,
        content: "删除后将无法恢复，您确定要删除吗？",
        onOk: async () => {
          let result = await delRanges(value.range_id)
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            detail();
          }
        },
      });
    };
    // 条件ID
    const range_id = ref("");
    // 查看出库单详情
    const outDetail = ref(false);
    const outSearch = ref({
      key_type: "to",
      keyword: "",
      start_time: "",
      end_time: "",
      limit: 5,
      page: 1,
      total: 0,
    });
    const outList = ref([]);
    const outColumns = [
      {
        title: "出库单号",
        dataIndex: "out_warehousing_sn",
        key: "out_warehousing_sn",
      },
      {
        title: "收货名称",
        dataIndex: "out_warehousing_to_name",
        key: "out_warehousing_to_name",
      },
      {
        title: "发货时间",
        dataIndex: "out_warehousing_time",
        key: "out_warehousing_time",
      },
      {
        title: "出库仓库",
        dataIndex: "warehouse_position_name",
        key: "warehouse_position_name",
      },
      {
        title: "实际数量",
        dataIndex: "out_warehousing_real_num",
        key: "out_warehousing_real_num",
      },
    ];
    // 时间筛选
    const onChange = (e) => {
      outSearch.value.start_time = e[0];
      outSearch.value.end_time = e[1];
    };
    const showOut = async (data) => {
      if (data) {
        range_id.value = data.range_id;
        outSearch.value = {
          key_type: "to",
          keyword: "",
          start_time: "",
          end_time: "",
          limit: 5,
          page: 1,
          total: 0,
        };
      }
      let result = await activitysRangeOutList(range_id.value, outSearch.value)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        outDetail.value = true;
        outList.value = result.data;
      }
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      outSearch.value = { ...outSearch.value, page: 1 };
      showOut();
    };
    // 编辑
    var is_edit = ref(false);
    const editOut = async (data) => {
      is_edit.value = data.range_id;
      let result = await activitysRangeOutList(data.range_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        outList.value = result.data;
        warehousingListVisible.value = true;
      }
    };

    // 查看自动匹配详情
    const autoDetailVisible = ref(false);
    const autoDetail = ref();
    const showCondition = async (data) => {
      let result = await show_range_info(data.range_id)
        .then((res) => res.data)
        .catch((error) => error);
      autoDetail.value = result.data;
      autoDetailVisible.value = true;
    };
    const storeColumns = [
      {
        title: "门店编号",
        dataIndex: "store_code",
        key: "store_code",
      },
      {
        title: "门店名称",
        dataIndex: "store_name",
        key: "store_name",
      },
      {
        title: "门店类型",
        dataIndex: "type_name",
        key: "type_name",
      },
      {
        title: "负责人",
        dataIndex: "clerk_name",
        key: "clerk_name",
      },
      {
        title: "手机号码",
        dataIndex: "clerk_phone",
        key: "clerk_phone",
      },
    ];
    const dealerColumns = [
      {
        title: "经销商编号",
        dataIndex: "dealer_sn",
        key: "dealer_sn",
      },
      {
        title: "经销商名称",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
      {
        title: "经销商级别",
        dataIndex: "level_name",
        key: "level_name",
      },
      {
        title: "负责人",
        dataIndex: "leader_name",
        key: "leader_name",
      },
      {
        title: "手机号码",
        dataIndex: "leader_phone",
        key: "leader_phone",
      },
    ];
    const goodsColumns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
      },

      {
        title: "商品信息",
        dataIndex: "info",
        key: "info",
        slots: { customRender: "info" },
      },
      {
        title: "产品库分类",
        dataIndex: "category",
        key: "category",
        slots: { customRender: "category" },
      },
      {
        title: "价格/元",
        dataIndex: "product_price",
        key: "product_price",
      },
    ];

    // 编辑自动匹配
    const editCondition=(data)=>{
      is_edit.value=data.range_id
      conditionVisible.value=true
    }
    return {
      columns,
      list,
      listLoading,
      detail,
      del,
      updateData,
      logColumns,
      logList,
      logVisible,
      showLogs,
      pageSizeChange,
      warehousingListVisible,
      pageCurrentChange,
      logSearch,
      selectWare,
      addMode,
      conditionVisible,
      successCondition,
      updateWayVisible,
      updateValue,
      setWay,
      delHandle,
      outColumns,
      outDetail,
      outList,
      showOut,
      onChange,
      pageSearchChange,
      outSearch,
      is_edit,
      editOut,
      autoDetail,
      autoDetailVisible,
      showCondition,
      storeColumns,
      dealerColumns,
      goodsColumns,
            info: store.state.user.info,
            editCondition
    };
  },
};
</script>
<style lang="less" scoped>
.customerModal{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  .mask{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.2);
  }
  .ModalContent{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    width: 456px;
    height: 240px;
    display: flex;
    justify-content: center;
    align-items: center;
    div{
    width: 180px;
    height: 180px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    &:nth-child(1){
      margin-right: 48px;
    }
      &:hover{
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>